import { render, staticRenderFns } from "./CommCdLangModal.vue?vue&type=template&id=d5b3ba10&"
import script from "./CommCdLangModal.vue?vue&type=script&lang=js&"
export * from "./CommCdLangModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports